<template>
  <div class="al-header" :style="{'background': bg}">
    <img src="@/assets/image/back.png" v-if="!zai && reback" class="al-back" @click="$router.go(-1)" alt="">
    <img src="@/assets/image/back.png" v-if="zai && !reback" class="al-back" @click="$router.go(-1)" alt="">
    <div class="al-title">{{titles}}</div>
    <div class="al-right">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
import Cookie from 'js-cookie'
export default {
  name: 'Header',
  props:{
    titles: String,
    zai: String,
    bg: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      reback : false
    }
  },
  created() {
    if(Cookie.get('token')) {
      this.reback = true
    }
  },
  methods: {
  }
}
</script>

<style lang="scss">
.al-header {
  z-index: 599;
  position: fixed;
  top: 0;
  height: 44px;
  color: white;
  background: linear-gradient(159deg, #0286FF 0%, #074FC7 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  .al-right {
    right: 18px;
    font-size: 15px;
    position: absolute;
  }
  .al-back {
    width: 12px;
    height: 21px;
    position: absolute;
    left: 10px;
  }
  .al-title {
    font-size:17px;
  }
}
</style>